import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard, CostingGuard, LoginGuard, MgtAdminGuard } from './auth-guard.service';
import {
  CustomerResolver,
  InventoryResolver,
  PurchaseOrderResolver,
  ServerHealthResolver,
  SupplierResolver
} from './component-resolvers';
import { RouteGuard } from './route-guard.service';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' }, // Set route
  {
    path: 'login',
    loadComponent: () => import('./core/index').then(com => com.LoginComponent),
    canActivate: [LoginGuard]
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./core/index').then(com => com.PasswordResetComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./core/index').then(com => com.UnauthorizedComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'connection-lost',
    loadComponent: () => import('./core/index').then(com => com.ConnectionLostComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'nxtgen-documents',
    loadComponent: () => import('./core/index').then(com => com.NxtgenDocumentsComponent),
    canActivate: [AuthGuard],
  },
  { // dashboards
    path: 'dashboards',
    loadChildren: () => import('./core/components/dashboards/dashboards.routes').then(routes => routes.DashboardsRoutes),
    resolve: { serverHealth: ServerHealthResolver }
  },
  {
    path: 'hello-world',
    loadComponent: () => import('./core/index').then(com => com.HelloWorldComponent),
    canActivate: [AuthGuard],
  },
  { // reports
    path: 'reports',
    loadChildren: () => import('./core/components/reports/reports.routes').then(routes => routes.ReportRoutes),
  },
  { // management reports
    path: 'management-reports',
    loadChildren: () => import('./modules/management-report/management-reports.routes').then(routes => routes.ManagementReportRoutes),
  },
  { // exchange rate
    path: 'exchange-rate',
    loadChildren: () => import('./core/components/exchange-rate/exchange-rate.routes').then(routes => routes.ExchangeRateRoutes),
  },
  { // inventory
    path: 'inventory',
    loadChildren: () => import('./core/components/inventory/inventory.routes').then(routes => routes.InventoryRoutes),
  },
  { // supplier
    path: 'supplier',
    loadChildren: () => import('./core/components/supplier/supplier.routes').then(routes => routes.SupplierRoutes),
  },
  { // customer
    path: 'customer',
    loadChildren: () => import('./core/components/customer/customer.routes').then(routes => routes.CustomerRoutes),
  },
  { // purchase-order
    path: 'purchase-order',
    loadChildren: () => import('./core/components/purchase-order/po.routes').then(routes => routes.PORoutes),
  },
  { // grn
    path: 'grn',
    loadChildren: () => import('./core/components/grn/grn.routes').then(routes => routes.GRNRoutes),
  },
  { // material-request
    path: 'material-request',
    loadChildren: () => import('./core/components/material-request/material-request.routes').then(routes => routes.MaterialRequestRoutes),
  },
  { // material-return
    path: 'material-return',
    loadChildren: () => import('./core/components/material-return/material-return.routes').then(routes => routes.MaterialReturnRoutes),
  },
  { // gin
    path: 'gin',
    loadChildren: () => import('./core/components/gin/gin.routes').then(routes => routes.GINRoutes),
  },
  { // employee 
    path: 'employee',
    loadChildren: () => import('./core/components/employee/employee.routes').then(routes => routes.EmployeeRoutes),
  },
  { // sales-inquiry
    path: 'sales-inquery',
    loadChildren: () => import('./core/components/sales-inquery/sales-inquery.routes').then(routes => routes.SalesInqueryRoutes),
  },
  { // product-development
    path: 'product-development',
    loadChildren: () => import('./core/components/product-development/product-development.routes').then(routes => routes.ProductDevelopmentRoutes),
  },
  { // quotation
    path: 'quotation',
    loadChildren: () => import('./core/components/quotation/quotation.routes').then(routes => routes.QuotationRoutes),
  },
  { // sales-order
    path: 'sales-order',
    loadChildren: () => import('./core/components/sales-order/sales-order.routes').then(routes => routes.SalesOrderRoutes),
  },
  { // npd
    path: 'npd',
    loadChildren: () => import('./core/components/npd/npd.routes').then(routes => routes.NpdRoutes),
  },
  { // finished-good
    path: 'finished-good',
    loadChildren: () => import('./core/components/finished-good/finished-goods.routes').then(routes => routes.FinishedGoodRoutes),
  },
  { // packing
    path: 'packing',
    loadChildren: () => import('./core/components/packing/packing.routes').then(routes => routes.PackingRoutes),
  },
  { // dispatch
    path: 'dispatch',
    loadChildren: () => import('./core/components/dispatch/dispatch.routes').then(routes => routes.DispatchRoutes),
  },
  { // invoice
    path: 'invoice',
    loadChildren: () => import('./core/components/invoice/invoice.routes').then(routes => routes.InvoiceRoutes),
  },
  { // artwork
    path: 'artwork',
    loadChildren: () => import('./core/components/artwork/artwork.routes').then(routes => routes.ArtworkRoutes),
  },
  { // customer receipt
    path: 'customer-receipt',
    loadChildren: () => import('./modules/customer-receipt/customer-receipt.routes').then(routes => routes.CustomerReceiptRoutes),
  },
  { // customer transaction
    path: 'customer-transaction',
    loadChildren: () => import('./modules/customer-transaction/customer-transaction.routes').then(routes => routes.CustomerTransactionRoutes),
  },
  { // warehouse
    path: 'warehouse',
    loadChildren: () => import('./core/components/warehouse/warehouse.routes').then(routes => routes.warehouseRoutes),
  },
  { // ncr
    path: 'ncr',
    loadChildren: () => import('./modules/ncr/ncr.routes').then(routes => routes.NCRRoutes),
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
